import {
  formatToPersianAddComma,
  parseToEnRemoveComma,
} from "../../utils/CommaSeparator";

export const calculateSumOfEachRow = (tableArray = []) => {
  const tableData = [...tableArray];
  tableData.forEach((singleRow, index) => {
    let { price, discount, number } = singleRow;
    if (price === undefined) price = 0;
    if (discount === undefined) discount = 0;
    if (number === undefined) number = 0;

    singleRow.totalSum =
      (parseInt(parseToEnRemoveComma(price)) -
        parseInt(parseToEnRemoveComma(discount))) *
      parseFloat(parseToEnRemoveComma(number));
    singleRow.totalSum = formatToPersianAddComma(singleRow.totalSum);
  });
  return tableData;
};

export const deleteRowHandler = (tableArray, productCode) => {
  const table = [...tableArray];

  table.forEach((row, index) => {
    if (row.productCode === productCode) {
      table.splice(index, 1);
    }
  });
  return table;
};

export const updateTableCellHandler = (
  tableArray,
  productCode,
  field,
  newValue
) => {
  const table = [...tableArray];

  table.forEach((row, index) => {
    if (row.productCode === productCode ) {
      row[field] = newValue;
    }
  });
  return table;
};
export const calculateSumOfTableData = (tableArray) => {
  if (tableArray) {
    const table = [...tableArray];
    return table.reduce((a, b) => a + +parseToEnRemoveComma(b.total), 0);
  }
  return 0;
};

export const sumOfPaymentTable = (priceData) => {
  const table = [...priceData];
  return table.reduce((a, b) => a + +b.price, 0);
};

export const calculateTotalSum = (sendData) => {
  const data = { ...sendData };
  let totalSum = 0;
  let taxPrice = 0;
  if (Object.keys(data).length > 0) {
    if (data.servicePrice === undefined) data.servicePrice = 0;
    if (data.totalDiscount === undefined) data.totalDiscount = 0;
    if (data.tax === undefined) data.tax = 0;

    const sumBeforeDiscount =
      calculateSumOfTableData(data.tableData) + +data.servicePrice;
    const sumAfterDiscount = sumBeforeDiscount - data.totalDiscount;
    totalSum = sumAfterDiscount * (1 + data.tax / 100);
    taxPrice = totalSum - sumAfterDiscount;
  }

  return { sum: Math.floor(totalSum), taxPrice };
};

export const isPaymentAndFactorSumEqual = (sendData) => {
  const data = { ...sendData };

  const totalSum = calculateTotalSum(data).sum;
  const totalPayments = sumOfPaymentTable(data.priceData);

  // const priceData1 = sumOfPaymentTable(priceData)
  // const sumOfAllFactor1 = calculateSumOfTableData(sumOfAllFactor)
  return totalSum === totalPayments;
};

export const myCustomCelEditFunction = (
  sendData,
  setSendData,
  cell,
  field,
  newValue
) => {
  const productCode = cell.getData().productCode;
  const tableData = updateTableCellHandler(
    sendData.tableData,
    productCode,
    field,
    newValue
  );
  setSendData({ tableData });
};

